import React from 'react'
import Certificate from './Certificate'

export default function CertificatePrintWrapper(props) {
  const {badges} = props;
  
  return (
    <React.Fragment>
      <div id="badgeCertificatesPrintWrapper" style={{display: 'none'}}>
        {badges.map(badge => <Certificate key={badge.id} {...badge} isColorPrint={true} />)}
      </div>
      <div id="badgeCertificatesPrintWrapperMonochrome" style={{display: 'none'}}>
        {badges.map(badge => <Certificate key={badge.id} {...badge} isColorPrint={false} />)}
      </div>
    </React.Fragment>
  )
}

export function printCertificates(isColorPrint=true) {
  let id = 'badgeCertificatesPrintWrapper';
  if (!isColorPrint) id = 'badgeCertificatesPrintWrapperMonochrome';
  const certificates = document.getElementById(id).innerHTML;
  const printWindowHtml = `
  <html>
    <head>
      <link rel="preconnect" href="https://fonts.googleapis.com">
      <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
      <link href="https://fonts.googleapis.com/css2?family=Quicksand:wght@400;500;600;700&display=swap" rel="stylesheet">
      <style type="text/css">
        @page {
          size: landscape; margin: 0;
        }
        body {
          margin: 0;
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
        }
        * {
          box-sizing: border-box;
        }
      </style>
    </head>
    <body>${certificates}</body>
  </html>`

  const printWindow = window.open('');
  printWindow.document.write(printWindowHtml);
  printWindow.document.close(); // necessary for IE >= 10
  printWindow.document.fonts.onloadingdone = () => {
    printWindow.focus(); // necessary for IE >= 10
    printWindow.print();
    printWindow.close();
  }
}